menutoggler = function(){
	this.init();
	
	this.init = function() {

	}
}